export const ADD_SAMPLE = 'addSample';
export const UPDATE_SAMPLE = 'updateSample';
export const GET_SAMPLES = 'getSamples';
export const DELETE_SAMPLE = 'deleteSample';
export const SET_TOKEN = 'setToken';
export const SET_ADMIN = 'setAdmin';

export const GET_FOLDERS = 'getFolders';
export const CREATE_FOLDER = 'createFolder';
export const SELECT_FOLDER = 'selectFolder';

export const ADD_LIGHT = 'addLight';
export const ADD_PANEL_TEMPERATURE = 'addPanelTemperature';
export const CLEAR_LIGHTS = 'clearLight';
export const CLEAR_PANEL_TEMPERATURES = 'clearPanelTemperatures';

export const SET_LIGHT = 'setLight';
export const SET_PANEL_TEMPERATURE = 'setPanelTemperature';

export const SET_SENSOR_READING = 'setSensorReading';

export const SET_SENSOR_CONNECTED = 'setSensorConnected';

